import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
} from "@mui/material";
import React, { Children } from "react";
import Draggable from "react-draggable";

function PaperComponent(props: any) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

interface IMDDragable {
  children?: JSX.Element[] | JSX.Element;
  title: string;
  desciption: string;
  open: true | false;
  setOpen: any;
  buttons: JSX.Element[] | JSX.Element;
}

const MDDragable: React.FunctionComponent<IMDDragable> = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={() => props.setOpen(false)}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{props.desciption}</DialogContentText>
      </DialogContent>
      <DialogActions>{props.buttons}</DialogActions>
    </Dialog>
  );
};

export default MDDragable;
